import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Button, Loading } from "@atoms";
import { h5, h7, body1, body2 } from '@typo/typo.module.css';
import { textPrimary, textSecondary } from '@typo/color.module.css';

import { useMutation, useQuery } from "@apollo/react-hooks";
import { useAlert } from "react-alert";
import { customerUpdate } from "@components/pages/ContactPage/__generated__/customerUpdate";
import { CUSTOMER_UPDATE } from "@components/pages/ContactPage/queries";
import { joinErrorMessages } from "@utils";
import { useOtp } from "@src/hooks/useOtp";
import { MaccaronTextField } from "@molecules/MaccaronTextField";
import completeIcon from "./images/complete.png";
import { useFormik } from "formik";
import { verifyOtp } from "@src/hooks/useOtp/__generated__/verifyOtp";

export interface IProps {
  show: boolean;
  onHide: any;
  closeNotifyMe: any;
  forceCheckout : any;
}


const OtpVerificationModal: React.FC<IProps> = (
  {
    show, onHide, forceCheckout
  }: IProps) => {
  const alert = useAlert();

  const [currentStep, setCurrentStep] = useState(1);

  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
      otp: "",
    },
    onSubmit: (values) => {

    },
  });

  const {
    otpRequested,
    setOtpRequested,
    otpVerified,
    setOtpVerified,
    disableOtpRequest,
    setDisableOtpRequest,
    otpId,
    otpValue,
    errors: otpErrors, //TODO: error handling (1 minute rule)
    handleRequestOtp,
    handleVerifyOtp,
  } = useOtp();

  const handleNextClick = () => {
    let isSuccess = false;
    switch (currentStep) {
      case 1:
        isSuccess = true;
        break;
      case 2:
        // OTP 요청
        // 번호 검증
        isSuccess = handleRequestOtp(formik.values.mobileNumber.toString());
        break;
      case 3:
        // OTP 인증
        // OTP 검증
        handleVerifyOtp(formik.values.otp.toString(), formik.values.mobileNumber.toString(), onVerifyOtpCompleted)
        break;
      case 4:
        // Checkout 실행하기
        forceCheckout();
      default:
        // 완료
        onHide();
    }
    if (isSuccess) {
      setCurrentStep(currentStep + 1);
    }
  }

  const onVerifyOtpCompleted = (result: verifyOtp) => {
    if (result['data']['verifyOtp']['verified']) {
      setCurrentStep(4);
    }
  }

  const handleBackClick = () => {
    setCurrentStep(currentStep - 1);
  }

  return (
    <div>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          {
            currentStep == 4 ?
              <label className={h5}>Complete!</label>
              :
              <label className={h5}>OTP Verification</label>
          }
        </Modal.Header>
        <Modal.Body style={{textAlign: "center"}}>
          {
            currentStep == 1 ?
              <>
                <label className={[h7, textPrimary].join(' ')} style={{margin: "0 2.5rem 0.5rem 2.5rem"}}>Please verify your mobile number <br/>to get a notification of delivery status!</label>
                <label className={[body2, textSecondary].join(' ')}>OTP Verification is also required for <br/>installment payment with <b>Simpl</b></label>
              </> :
              currentStep == 2 ?
                <>
                  <label className={[body2, textSecondary].join(' ')}>We will send you an OTP number on this mobile number</label>
                  <MaccaronTextField
                    placeholder="+ 91 Mobile Number"
                    type="number"
                    name="mobileNumber"
                    value={formik?.values?.mobileNumber}
                    onChange={formik?.handleChange}
                    maxLength={10}
                  />
                </> :
                currentStep == 3 ?
                  <>
                    <label className={[body2, textSecondary].join(' ')}>Enter the OTP you received on +91 {formik.values.mobileNumber}</label>
                    <MaccaronTextField
                      name="otp"
                      placeholder="OTP"
                      type="number"
                      maxLength={6}
                      value={formik?.values?.otp}
                      onChange={formik?.handleChange}
                    />
                  </> :
                  <div>
                    <label className={[body2, textSecondary].join(' ')}>Now you can receive all the notifications via message.</label>
                    <img src={completeIcon} width={"2.5rem"}/>
                  </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Row style={{width: "100%"}}>
            <Col>
              {
                currentStep == 1 ?
                  <Button style={{width: "100%"}} onClick={handleNextClick}>Verify</Button>
                  :
                  currentStep == 2 ?
                    <Button style={{width: "100%"}} onClick={handleNextClick}>Next</Button>
                    :
                    currentStep == 3 ?
                      <Button style={{width: "100%"}} onClick={handleNextClick}>Verify & Proceed</Button>
                      :
                      <Button style={{width: "100%"}} onClick={handleNextClick}>Continue</Button>
              }
            </Col>
          </Row>
          <Row style={{width: "100%"}}>
            <Col style={{textAlign: "center"}}>
              {
                currentStep == 1 ?
                  <a href="#" style={{padding: "0.75rem", textDecoration: "underline"}} onClick={forceCheckout} className={[body1, textSecondary].join(" ")}>Checkout without verification</a>
                  : currentStep == 4 ?
                    <></>
                    :
                    <a href="#" style={{padding: "0.75rem", textDecoration: "underline"}} onClick={handleBackClick} className={[body1, textSecondary].join(" ")}>Back</a>
              }
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
};

export { OtpVerificationModal }